import type {
  LoginRes,
  User,
} from '@school-manage/api/actions/auth/auth.types';

import { ZustandIDBStorage } from '@school-manage/common/others/storage/ZustandIDBStorage';
import { getOpenReplay } from '@school-manage/utils/open-replay';
import {
  sentryCaptureException,
  sentrySetUser,
} from '@school-manage/utils/sentry';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface Auth {
  authData?: LoginRes;
  removeUser: () => void;
  setAuthData: (data?: LoginRes) => void;
  setUser: (data: User) => void;
}

const STORAGE_NAME = 'auth-storage';

export const useAuthStore = create<Auth>()(
  devtools(
    persist(
      (set, get) => ({
        authData: undefined,
        removeUser: () => {
          set({ authData: undefined });
        },
        setAuthData: (data) => {
          try {
            const user = data?.user;
            if (user?.uuid) {
              getOpenReplay()?.setUserID(user.uuid);
              sentrySetUser({
                id: user.uuid,
                username: user?.student_no,
              });
            }
          } catch (error) {
            sentryCaptureException(error);
          }
          set({ authData: data });
        },
        setUser: (data) => {
          const { authData } = get();
          if (!authData) return;
          set({
            authData: {
              ...authData,
              user: data,
            },
          });
        },
      }),
      {
        name: STORAGE_NAME,
        partialize: (state) => ({ authData: state.authData }),
        storage: new ZustandIDBStorage(),
      }
    ),
    {
      name: STORAGE_NAME,
    }
  )
);
